import * as R from 'ramda'
import { Meta } from '@weblite-wapps/protocol'
import { findRunningWapp, WappParentType } from 'weblite-web-wapprunner'
import { showWappDrawer } from '$comp/modals/wapp-drawer'
import { getWis } from '$logic/wises'
import { getWapp } from '$logic/wapps/service'
import { wappModesByIdView } from '$logic/wapps/wapps.reducer'
import {
  registerAwaitingParent,
  resolveAwaitingParent,
} from '../helper/awaitingParentsForOutput'

export const oldWappHasMode = ({
  wappId,
  mode,
}: {
  wappId: string
  mode: string
}) => R.includes(mode, wappModesByIdView(wappId))

export const modeIsFeasibleToChangeTo = ({
  oldMode,
  newMode,
  wappId,
}: {
  oldMode: string
  newMode: string
  wappId: string
}) =>
  oldMode !== newMode &&
  (newMode === 'fullscreen' || newMode === 'main') &&
  oldWappHasMode({ wappId, mode: newMode })

export function returnOldWappOutputToParent(
  wappSessionId: string,
  output?: any | 'canceled',
) {
  const { parent, output: alreadyAvailableOutput, mode } =
    findRunningWapp(wappSessionId) || {}

  console.log('>>> parent:', parent)
  if (!parent || parent.type === WappParentType.WAPP) return

  if (output === 'canceled') {
    resolveAwaitingParent(parent.resolverId, { error: 'canceled' })
    return
  }

  const outputToReturn = output || alreadyAvailableOutput
  console.log('>>> output to return:', outputToReturn)
  if (!outputToReturn) return

  resolveAwaitingParent(parent.resolverId, { output: outputToReturn })
}

export const openWappInDrawer = (
  wappInfo: {
    wappId: string
    wisId: string
    input: any
    options?: { headerText?: string }
  },
  parent: Meta,
  {
    isFullScreen,
    isForced,
  }: { isFullScreen?: boolean; isForced?: boolean } = {},
) =>
  new Promise(async resolve => {
    const { wappId, wisId, input, options } = wappInfo

    const wapp = await getWapp(wappInfo.wappId)
    if (!wapp) return

    if (wisId) {
      const wis = await getWis(wisId)
      if (!wis) return
    }

    await showWappDrawer({
      title: options?.headerText || '',
      wappId,
      wisId,
      input,
      parent: {
        type: WappParentType.NON_WAPP,
        resolverId: registerAwaitingParent(resolve),
      },
      isForced,
      isFullScreen,
    })
  })
